/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Isorganizationalunit2Inputs */

const en_entity_isorganizationalunit2 = /** @type {(inputs: Entity_Isorganizationalunit2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Organizational Unit`)
};

const de_entity_isorganizationalunit2 = /** @type {(inputs: Entity_Isorganizationalunit2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist Organisationseinheit`)
};

/**
* | output |
* | --- |
* | "Is Organizational Unit" |
*
* @param {Entity_Isorganizationalunit2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_isorganizationalunit2 = /** @type {((inputs?: Entity_Isorganizationalunit2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Isorganizationalunit2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_isorganizationalunit2(inputs)
	return de_entity_isorganizationalunit2(inputs)
});
export { entity_isorganizationalunit2 as "entity_isOrganizationalUnit" }